import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import {
    LayoutDashboard,
    Users,
    MessageSquare,
    X
} from 'lucide-react';
import HRBackofficeDashboard from './hr-backoffice/HRBackofficeDashboard';
import CandidateProfileManagement from './recruitment/CandidateProfileManagement';
import OfferCommunicationLogs from './recruitment/OfferCommunicationLogs';
import ViewCandidate from './recruitment/ViewCandidate';
import ViewCommunication from './recruitment/ViewCommunication';
import Drawer from '../../components/common/Drawer';
import PermissionGate from '../../components/common/PermissionGate';

const BackOfficeModule = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const location = useLocation();

    const currentTab = searchParams.get('tab') || 'dashboard';
    const action = searchParams.get('action');
    const actionId = searchParams.get('id');
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    useEffect(() => {
        if (action && actionId) {
            setIsDrawerOpen(true);
        } else {
            setIsDrawerOpen(false);
        }
    }, [action, actionId]);

    const tabs = [
        {
            id: 'dashboard',
            label: 'Dashboard',
            icon: LayoutDashboard,
            component: HRBackofficeDashboard,
            roles: ['super_admin', 'hr_manager', 'hr_executive'] // Broad access
        },
    ];

    const handleTabChange = (tabId) => {
        setSearchParams({ tab: tabId });
    };

    const closeDrawer = () => {
        setIsDrawerOpen(false);
        // Remove action/id but keep tab
        const newParams = new URLSearchParams(searchParams);
        newParams.delete('action');
        newParams.delete('id');
        setSearchParams(newParams);
    };

    // Handlers for child components to trigger drawer
    const handleViewCandidate = (candidate) => {
        navigate(`/view_candidate/${candidate.id}`, { state: { from: location.pathname + location.search } });
    };

    const handleViewCommunication = (commId) => {
        navigate(`/view_communication/${commId}`);
    };

    const getDrawerContent = () => {
        if (!actionId) return null;

        switch (action) {
            case 'viewCandidate':
                return (
                    <ViewCandidate
                        id={actionId}
                        onBack={closeDrawer}
                    />
                );
            default:
                return <div className="p-4">Unknown action</div>;
        }
    };

    const getDrawerTitle = () => {
        switch (action) {
            case 'viewCandidate': return 'Candidate Details';
            default: return 'Details';
        }
    };

    return (
        <div className="flex flex-col h-full bg-gray-50">
            {/* Module Header & Tabs */}
            {/* <div className="bg-white border-b border-gray-200 px-6 pt-6 sticky top-0 z-10 shadow-sm">
                <div className="flex items-center justify-between mb-6">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-900">Back-Office</h1>
                        <p className="text-sm text-gray-500 mt-1">
                            Centralized hub for HR operations and recruitment management
                        </p>
                    </div>
                </div>

              
                <div className="flex space-x-1 overflow-x-auto no-scrollbar">
                    {tabs.map((tab) => (
                        <button
                            key={tab.id}
                            onClick={() => handleTabChange(tab.id)}
                            className={`
                flex items-center space-x-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap
                ${currentTab === tab.id
                                    ? 'border-[#0F2942] text-[#0F2942]'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }
              `}
                        >
                            <tab.icon className={`h-4 w-4 ${currentTab === tab.id ? 'text-[#0F2942]' : 'text-gray-400'}`} />
                            <span>{tab.label}</span>
                        </button>
                    ))}
                </div>
            </div> */}

            {/* Main Content Area */}
            <div className="flex-1 overflow-y-auto p-6">
                {currentTab === 'dashboard' && <HRBackofficeDashboard />}

                {currentTab === 'candidateProfiles' && (
                    <PermissionGate permission="recruitment" action="read">
                        <CandidateProfileManagement onViewCandidate={handleViewCandidate} />
                    </PermissionGate>
                )}

                {currentTab === 'communicationLogs' && (
                    <PermissionGate permission="recruitment" action="read">
                        <OfferCommunicationLogs onViewCommunication={handleViewCommunication} />
                    </PermissionGate>
                )}
            </div>

            {/* Right-side Drawer */}
            <Drawer
                isOpen={isDrawerOpen}
                onClose={closeDrawer}
                title={getDrawerTitle()}
                width="w-full max-w-4xl"
            >
                {isDrawerOpen && getDrawerContent()}
            </Drawer>
        </div>
    );
};

export default BackOfficeModule;
